import React from "react";
import { Button, PropTypes } from "@material-ui/core";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const getLinkButton = (name: string, linkTo: string, icon: React.ReactNode, color: PropTypes.Color = "primary") => {
  return (
    <Link to={linkTo}>
      <Button variant="outlined" color={color} size="small" startIcon={icon}>
        {name}
      </Button>
    </Link>
  );
};

export const getClickButton = (
  name: string,
  icon: React.ReactNode,
  handleClick?: React.MouseEventHandler<HTMLButtonElement>,
  color: PropTypes.Color = "primary",
) => {
  return (
    <Button variant="outlined" color={color} size="small" startIcon={icon} onClick={handleClick}>
      {name}
    </Button>
  );
};

const BlackButton = styled(Button)`
  color: black;
  font-size: 1.17em;
  font-weight: bold;
`;

export const getTextClickButton = (name: string, icon: React.ReactNode, handleClick?: React.MouseEventHandler<HTMLButtonElement>) => {
  return (
    <BlackButton variant="text" size="small" startIcon={icon} onClick={handleClick}>
      {name}
    </BlackButton>
  );
};
